var map = {
	"./App.vue": "9HY0",
	"./Check.vue": "thbC",
	"./CheckTasks/TaskAdditionText.vue": "YeJU",
	"./CheckTasks/TaskAnswerSelector.vue": "lX+D",
	"./CheckTasks/TaskDifference.vue": "A+i4",
	"./CheckTasks/TaskOpinion.vue": "zyNt",
	"./CheckTasks/TaskPairingImage.vue": "QghP",
	"./CheckTasks/TaskPuzzle.vue": "jPJE",
	"./Game.vue": "Ytnb",
	"./Registration.vue": "ikWC",
	"./StartGame.vue": "n+th",
	"./Task/TaskAdditionText.vue": "3CNr",
	"./Task/TaskAnswerSelector.vue": "ccBb",
	"./Task/TaskDifference.vue": "RJIF",
	"./Task/TaskOpinion.vue": "Vdbq",
	"./Task/TaskPairingImage.vue": "x8ly",
	"./Task/TaskPuzzle.vue": "x5J0",
	"./Thanks.vue": "0QvW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CAA2";